import { compose, mdsWidget } from 'dojo/_base/declare';
import domConstruct from 'dojo/dom-construct';
import domStyle from 'dojo/dom-style';
import lang from 'dojo/_base/lang';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import _TemplatedMixin from 'dijit/_TemplatedMixin';
import template from './Title.html?raw';
import "../Icon/Icon";

class Title extends compose(_WidgetBaseSP, _TemplatedMixin) {
    [key: string]: any;

    templateString: any = template;
    onChange: any = function () { };

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.icon.onChange = lang.hitch(this, "_onChangeValue");
    }

    clear(): void {
        this.icon.clear();
        domStyle.set(this.domNode, "display", "none");
        this.text.innerHTML = "";
    }

    unSelect(): void {
        this.text.innerHTML = "";
    }
    getSelectedValues(): any {
        return {
            text: this.text.innerHTML,
            tooltip: this.icon.getSelectedValues().tooltip
        };
    }

    _onChangeValue(): void {
        this.onChange(this.getSelectedValues());
    }

    setTitle(Title: any, Tooltip: any): any {
        if (Title) {
            domConstruct.place(Title, this.text, "only");
            domStyle.set(this.domNode, "display", "inline");
        } else {
            domStyle.set(this.domNode, "display", "none");
        }

        if (Tooltip) {
            this.icon.tooltip.innerHTML = Tooltip;
            domStyle.set(this.icon.domNode, "display", "inline");
        } else {
            domStyle.set(this.icon.domNode, "display", "none");
        }
        return this;
    }
}
Title.prototype.declaredClass = 'more.Legacy.Zal.Title';

export default mdsWidget(Title);
